import {
    DATA_INGESTION_BATCH_STATUS_SUCCESS,
    DATA_INGESTION_BATCH_STATUS_LOADING

} from '../actions/DataIngestionBatchStatusAction';

const initialState = {
    dataIngestionBatchStatusData: null,
    isLoading: true,
};

const DataIngestionBatchStatusReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case DATA_INGESTION_BATCH_STATUS_SUCCESS:
            return { ...state, dataIngestionBatchStatusData: action.data, isLoading: false };

        case DATA_INGESTION_BATCH_STATUS_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default DataIngestionBatchStatusReducer;
